module.exports = __webpack_public_path__ + "img/homework-lesson.0ccc7a55.svg";